import {
  GET_WAREHOUSE_STOCK_ITEM,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/warehouse/stock/id/get'

import {
  WarehouseStockItem,
  WarehouseStockItemRequestParams,
  WarehouseStockAdjustParams,
} from 'app/common/types/warehouse/stock'

import { useCommonDataProvider, CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'

import { patchWarehouseStockItem } from '../patchWarehouseStockItem'

const defaultState: WarehouseStockItem | null = null

type Options = CommonDataOptions<WarehouseStockItem | null, WarehouseStockItemRequestParams>

export function useWarehouseStockItem(options: Options = {} as Options) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_WAREHOUSE_STOCK_ITEM,
    error: 'Не удалось получить одну из записей остатков склада',
    convertions: {
      convertParams,
      convertResult,
    },
    defaultState,
  })

  const adjustQuantity = async (params: WarehouseStockAdjustParams) => {
    const result = await patchWarehouseStockItem(params)
    if (result) {
      res.setData(result)
    }
    return result
  }

  return { ...res, adjustQuantity }
}
